var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"register-view"},[_c('div'),_c('icp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }